import React from "react"
import { useTranslation } from "react-i18next"
import { CustomProvider, DatePicker } from "rsuite"
import arEG from "rsuite/locales/ar_EG"
import enUS from "rsuite/locales/en_US"
import "rsuite/dist/rsuite.min.css"

const DATE_VALUE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

const formatDateValue = date => {
  if (!date) return ""
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`
}

const isValidDateString = value =>
  typeof value === "string" && DATE_VALUE_PATTERN.test(value)

const LocalizedDatePicker = ({
  value,
  onChange,
  placeholder,
  className,
  cleanable = true,
  editable = true,
  ...rest
}) => {
  const { t, i18n: { language } } = useTranslation()
  const baseLocale = language === "sa" ? arEG : enUS
  const locale = {
    ...baseLocale,
    DatePicker: {
      ...baseLocale.DatePicker,
      ok: t("OK"),
      clean: t("Clear"),
      today: t("Today"),
    },
  }
  const dateValue = value ? new Date(`${value}T00:00:00`) : null
  const parsedDate =
    dateValue && !Number.isNaN(dateValue.getTime()) ? dateValue : null

  return (
    <CustomProvider locale={locale}>
      <DatePicker
        block
        format="yyyy-MM-dd"
        value={parsedDate}
        onChange={date => {
          if (!date) {
            if (cleanable) onChange("")
            return
          }
          const formatted = formatDateValue(date)
          if (!isValidDateString(formatted)) return
          onChange(formatted)
        }}
        placeholder={placeholder}
        className={className}
        cleanable={cleanable}
        editable={editable}
        {...rest}
      />
    </CustomProvider>
  )
}

export default LocalizedDatePicker
